var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.85742 15.4824H11.6074V13.9824H7.85742C4.60242 13.9824 1.85742 11.2374 1.85742 7.98242C1.85742 4.72742 4.60242 1.98242 7.85742 1.98242C11.1124 1.98242 13.8574 4.72742 13.8574 7.98242V9.05492C13.8574 9.64742 13.3249 10.2324 12.7324 10.2324C12.1399 10.2324 11.6074 9.64742 11.6074 9.05492V7.98242C11.6074 5.91242 9.92742 4.23242 7.85742 4.23242C5.78742 4.23242 4.10742 5.91242 4.10742 7.98242C4.10742 10.0524 5.78742 11.7324 7.85742 11.7324C8.89242 11.7324 9.83742 11.3124 10.5124 10.6299C10.9999 11.2974 11.8399 11.7324 12.7324 11.7324C14.2099 11.7324 15.3574 10.5324 15.3574 9.05492V7.98242C15.3574 3.84242 11.9974 0.482422 7.85742 0.482422C3.71742 0.482422 0.357422 3.84242 0.357422 7.98242C0.357422 12.1224 3.71742 15.4824 7.85742 15.4824ZM7.85742 10.2324C6.61242 10.2324 5.60742 9.22742 5.60742 7.98242C5.60742 6.73742 6.61242 5.73242 7.85742 5.73242C9.10242 5.73242 10.1074 6.73742 10.1074 7.98242C10.1074 9.22742 9.10242 10.2324 7.85742 10.2324Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAt);
export default __webpack_public_path__ + "static/media/at.6034fd44d669ef7bc06eea09a54cc6c1.svg";
export { ForwardRef as ReactComponent };